import React, {useState, useEffect, useRef} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {getLanguage, t} from 'react-switch-lang';
import {
  getAllProcesses,
  createProcess,
  deleteProcess,
  updateProcess, deactivateProcess,
} from '../../../services/Processes/processes';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import Swal from "sweetalert2";
import AddIcon from '../Metodologies/plus.png';

const Processes = () => {
  const [processes, setProcesses] = useState([]);
  const [query, setQuery] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllProcesses();
        setProcesses(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  // Opcije za select moraju biti u formatu {value, label}

  // const formatedDepartments = processes.map((d) => ({
  //   label: d.name,
  //   value: d.id,
  // }));

  const columns = [
    {
      dataIndex: 'name',
      title: t('common.name'),
      editable: true,
      placeholder:`${t('common.placeholder.name')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('common.nameEn'),
      editable: true,
      placeholder:`${t('common.placeholder.nameEn')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.active = editingRecord.active
    data.id = editingRecord.id;
    try {
      const response = await updateProcess(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('message.updateSuccess2', {entity: t('processes.Process')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('processes.processExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('processes.processExists')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    data.active = true
    try {
      const response = await createProcess(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('message.addSuccess2', {entity: t('processes.Process')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('processes.processExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('processes.processExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    let response;
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('processes.Process'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete2').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            response = await deleteProcess(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {entity: t('processes.Process')}),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            if (err?.response?.data?.code === 'process_deactivation_blocked_by_open_risks') {
              Swal.fire({
                text: `${t("message.riskProcessDeactivationBlockedByOpenRisks")}`,
                icon: "error",
                confirmButtonText: "OK"
              });
            }else {
              Swal.fire({
                text: t('message.deleteFailed', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
                icon: 'error',
              });
            }
          }
        },
      });
    });
  };
  const onDeactivate = async (record) => {
    let response;
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title:
          record?.active
            ? `${t("buttons.deactivateBtn")} ${t('processes.process')}`
            :  `${t("buttons.activateBtn")} ${t('processes.process')}`,
        text:`${
          record?.active
            ? t("question.deactivate")
            : t("question.activate")
        } ${getLanguage() === "eng" ? record.nameEn : record.name}  ?`,
        confirmButtonText: record?.active
          ? t("buttons.deactivateBtn")
          : t("buttons.activateBtn"),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            response = await deactivateProcess(record?.id);
            if (response.status === 200) {
              Toast.fire({
                title: `${
                  record?.active
                    ? t("message.successDeactivate")
                    : t("message.successActivate")
                }`,
                icon: 'success',
              });
               setTimeout(() => {window.location.reload()}, 3000)
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            if (err?.response?.data?.code === 'process_deactivation_blocked_by_open_risks') {
              Swal.fire({
                text: `${t("message.riskProcessDeactivationBlockedByOpenRisks")}`,
                icon: "error",
                confirmButtonText: "OK"
              });
            }else {
              Swal.fire({
                text: `${t("message.errorApi")}`,
                icon: "error",
                confirmButtonText: "OK"
              });
            }
          }
        },
      });
    });
  };

  const addButton = useRef();

  return (
    <div className="processes administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search">
          <SearchBox
            placeholder={t('processes.searchProcesses')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('processes.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/processes"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        columns={columns}
        methods={{onUpdate, onDelete, onCreate, onDeactivate}}
        addButtonRef={addButton}
        actionsWidth={100}
        deactivateButton={true}
      />
    </div>
  );
};

export default Processes;